import * as React from "react";
import styled, { css } from "styled-components";
import useProductName from "brand-customization/useProductName";
import { Alert } from "components/bootstrap";
const StyledAlert = styled(Alert)(
  () => css`
    margin-top: 0;
  `
);
const RepositoryAccessInfo = () => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "info", title: "Credentials are needed in two places" }, productName, " and OpenSearch both connect to the repository. OpenSearch needs credentials in its keystore, and", " ", productName, " needs its own. ", productName, " credentials must be available on every ", productName, ' node, unless "Restrict Creation to Leader Node" is enabled in the archiving configuration.');
};
export default RepositoryAccessInfo;
